module.exports = __webpack_public_path__ + "img/print_drawed.7eb25b0c.png";